import client from '@stores/apollo'
import gql from 'graphql-tag'
import { IBookingImport } from '@api/types'
import { BookingImportFragment } from '@api/fragments'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  viewer: {
    company: {
      bookingImports: {
        edges: Array<{ node: IBookingImport }>
      }
    }
  }
}

const mutateHandler = handleFetchResult<IPayload, IBookingImport | undefined>({
  handler: ({
    viewer: {
      company: {
        bookingImports: { edges },
      },
    },
  }) => {
    return edges.find(({ node: { status } }) => status === 'pending' || status === 'queued')?.node
  },
  name: 'Booking Connection',
})

export default function isActive(): Promise<IBookingImport | undefined> {
  return client.gql.query({ query }).then(mutateHandler)
}

const query = gql`
  query isActive {
    viewer {
      company {
        bookingImports(first: 1) {
          edges {
            node {
              ...BookingImportFragment
            }
          }
        }
      }
    }
  }
  ${BookingImportFragment}
`
